import { process } from '@alife/tarot';

// 是否是生产环境
let isProduction = true;
try {
    /* eslint-disable no-undef */
    if (process.env.NODE_ENV !== 'production') {
        isProduction = false;
    }
    /* eslint-enable no-undef */
} catch (e) {
    // ...
}

const errLog = (option = {}) => {
    // 非线上环境不上报
    if (!isProduction) {
        return;
    }

    window.__WPO && window.__WPO.retCode(option.name, false, 0, '', option.message);
};

export default errLog;
